import type { RMetricGroupType } from '~/presentation/reports/common/type';

import { EReportColumnKey } from '~/presentation/reports/common/type';
import { ORDER_COLUMN_MAPPING } from '@gem-sdk/analytics';

export { ORDER_COLUMN_MAPPING, DEFAULT_SELECTED_COLUMNS_FOR_EXPERIMENT } from '@gem-sdk/analytics';

/**
 * Bump whenever a column is added to or removed from `ORDER_COLUMN_MAPPING`: the columns
 * popover renders the persisted order only, so an older snapshot hides the new column for
 * good. Bumping drops that snapshot — merchants re-pick their columns once.
 */
export const ORDER_COLUMNS_CONFIG_VERSION = 1;

export const ORDER_COLUMN_GROUP: RMetricGroupType = [
  {
    title: 'Columns',
    options: Object.values(ORDER_COLUMN_MAPPING),
  },
];

export const DEFAULT_SELECTED_COLUMNS_FOR_PAGE: EReportColumnKey[] = [
  EReportColumnKey.ORDER_ID,
  EReportColumnKey.ORDER_DATE,
  EReportColumnKey.TOTAL,
  EReportColumnKey.TRAFFIC_SOURCE,
  EReportColumnKey.DEVICE,
  EReportColumnKey.VISITOR,
  EReportColumnKey.ITEMS,
];
